import Vue from 'vue'

export default {
	data() {
		return {
			size: 10,
			total: 0,
			curPage: 1,
			imgDomainUrl: 'https://fastdfs.dscq.com/',
			downloadUrl: 'https://wfcquae.swuee.com/sync/'
		}
	},
	filters: {
		formatCurrency: function(value) {
			if(value == 0) return 0;
			if(isNaN(value) || value === "" || value === null || value === undefined || value === "undefined" || value === "null") return "--";
			var str = value.toString();
			if(str.indexOf(".") !== -1) {
				var str1 = str.split(".")[0],
					str2 = str.split(".")[1];
				return str1.replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') + "." + str2;
			} else return str.replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
		},
		dateFormat: function(time) {
			if(time && time.length === 10) {
				var date = new Date(parseInt(time) * 1000);
			} else if(time && time.length == 13) {
				var date = new Date(parseInt(time));
			}
			if(date) {
				var year = date.getFullYear();
				var month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
				var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
				var hours = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
				var minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
				var seconds = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
				return year + "-" + month + "-" + day;
			} else return "--";
		}
	}
}



// WEBPACK FOOTER //
// ./src/mixins/news.js